const Home = () => import('@/components/IDEC/Home');
const IdecLogin = () => import('@/components/IDEC/IdecLogin');
const IdecForgotPassword = () => import('@/components/IDEC/IdecForgotPassword');
const SignUp = () => import('@/components/IDEC/SignUp');
const IdecSignUp = () => import('@/components/IDEC/IdecSignUp');
const Courseknowmore = () => import('@/components/IDEC/Courseknowmore');
const Basic_Course_in_Diabetology = () => import('@/components/IDEC/Basic_Course_in_Diabetology');
const Advanced_Certificate_Course_in_Diabetology = () => import('@/components/IDEC/Advanced_Certificate_Course_in_Diabetology');
const course = () => import('@/components/IDEC/course');
const aboutus = () => import('@/components/IDEC/aboutus');
const contact = () => import('@/components/IDEC/contact');
const news_media = () => import('@/components/IDEC/news_media');
const getuserInfo = () => import('@/components/IDEC/getUserInfo');
const CourseInfo = () => import('@/components/IDEC/CourseInfo');
const authentication = () => import('@/components/IDEC/authentication');
const SeeAllCourses = () => import('@/components/IDEC/SeeAllCourses');
///AirPay
const BuyCourse = () => import('@/components/IDEC/AirPay/BuyCourse');
const routes = [
  {
    path: '/airpay-test',
    name: 'airpay-test',
    component: BuyCourse,
},
/////////////////
    {
        path: '/idec-login',
        name: 'idec-login',
        component: IdecLogin,
   },
   {
    path: '/idec-home',
    name: 'idec-home',
    component: Home,
    props: true,
    meta:{breadcrumb: 'Dashboard'},
  },
   {
    path: '/isignup',
    name: 'isignup',
    component: SignUp,
  },
   {
    path: '/idecsignup',
    name: 'idecsignup',
    component: IdecSignUp,
  },
   {
    path: '/idec-forgot-password',
    name: 'idec-forgot-password',
    component: IdecForgotPassword,
  },
  
  {
    path: '/idec-course-know-more',
    name: 'idec-course-know-more',
    component: Courseknowmore,
    meta: { breadcrumb: router => `${router.id} ` },
  },
  {
    path: '/basic-course-in-diabetology',
    name: 'basic-course-in-diabetology',
    component: Basic_Course_in_Diabetology,
    meta: { breadcrumb: 'Basic Course in Diabetology' },
  },
  {
    path: '/idec-course',
    name: 'idec-course',
    component: course,
    meta: { breadcrumb: 'course' },
  },
  {
    path: '/idec-aboutus',
    name: 'idec-aboutus',
    component: aboutus,
    meta: { breadcrumb: 'aboutus' },
  },
  {
    path: '/idec-news_media',
    name: 'idec-news_media',
    component: news_media,
    meta: { breadcrumb: 'news_media' },
  },
  {
    path: '/idec-contact',
    name: 'idec-contact',
    component: contact,
    meta: { breadcrumb: 'contact' },
  },
  {
    path: '/advanced-certificate-course-in-diabetology',
    name: 'advanced-certificate-course-in-diabetology',
    component: Advanced_Certificate_Course_in_Diabetology,
    meta: { breadcrumb: 'Advanced Certificate Course in Diabetology' },
  },
  {
    path: '/get-user-info',
    name: 'get-user-info',
    component: getuserInfo,
  },
  {
    path: '/idec-course-info/:id',
    name: 'idec-course-info',
    component: CourseInfo,
  },
  {
    path: '/idec-authentication/',
    name: 'idec-authentication',
    component: authentication,
  },
  {
    path: '/idec-see-all-course-details',
    name: 'idec-see-all-course-details',
    component: SeeAllCourses,
  },
]
export default routes